import Vue from 'vue'
import App from './App.vue'
import Vuelidate  from 'vuelidate'
import VueResource from 'vue-resource'
import { store } from "../store/store"
 
 
 

Vue.use(Vuelidate)
Vue.use(VueResource)

//Vue.http.options.root  ="https://ws.monoryum.com/token";


new Vue({
  el: '#app',
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js